const PropTypes = require('prop-types');
// @vendors
const React = require('react');

const BuySellConditionTypeValue = ({
        value
}) => {
    const { label } = value;

    return (
        <div className="buysell-condition-type-dropdown__value">
            <span className="buysell-condition-type__value-label">{label}</span>
        </div>
    );
};

BuySellConditionTypeValue.propTypes = {
    value: PropTypes.object
};

module.exports = BuySellConditionTypeValue;
